module.exports = __webpack_public_path__ + "static/media/user-authentication.ed884134.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/user-authentication.png
// module id = 1555
// module chunks = 0